import type { ShipSnapshot } from "@frontier/protocol/contracts";
export function confirmedShipDeaths(
  previous: readonly Pick<ShipSnapshot, "id" | "dead">[],
  current: readonly Pick<ShipSnapshot, "id" | "dead">[],
): Set<string> {
  const alive = new Set(
    previous.filter((ship) => !ship.dead).map((ship) => ship.id),
  );
  return new Set(
    current
      .filter((ship) => ship.dead && alive.has(ship.id))
      .map((ship) => ship.id),
  );
}
